import fetch from './index';

// 创建上传视频的凭证
const createVideo = (data: object) => fetch.axios_admin.post('/createVideo', data);

// 刷新视频凭证
const refreshVideo = (video: string) => fetch.axios_admin.post(`/refreshVideo?videoId=${video}`);

// 保存视频信息
const saveCreateVideo = (params: object) => fetch.axios_admin.post('/video', params);

// 修改视频信息
const updateVideo = (params: object) => fetch.axios_admin.put('/video', params);

// 删除视频信息
const removeVideo = (videoId: string) => fetch.axios_admin.remove(`video/${videoId}`);

// 获得视频列表
const getVideoList = (params: object, title: string) => fetch.axios_admin.get(`video?&title=${title}`, { params });

// 获得视频列表
const playVideo = (videoId: string) => fetch.axios_admin.post(`playVideo?videoId=${videoId}`);

export default {
  createVideo,
  saveCreateVideo,
  refreshVideo,
  getVideoList,
  playVideo,
  updateVideo,
  removeVideo,
};
